import { PortalLink } from '@vs/ui/portal/link';
import { useEnv } from '@vs/utils/envConfig';
import { memo } from 'react';
import { Trans, useTranslation } from 'react-i18next';

import {
  PortalFooterContainer,
  PropsPortalFooterContainer,
} from './portal-footer-container';

export type PortalFooterProps = {
  mode?: PropsPortalFooterContainer['mode'];
};

export function PortalFooter({ mode }: PortalFooterProps) {
  const { t } = useTranslation();
  const env = useEnv();
  const { legalDoc } = env.appUrl;

  return (
    <PortalFooterContainer mode={mode}>
      <Trans
        i18nKey="shared:footer.privacy_policy"
        t={t}
        components={{
          a: (
            <PortalLink
              href={`${legalDoc}/privacy-policy`}
              target="_blank"
              variant="default"
              underlineOnHover
            >
              0
            </PortalLink>
          ),
        }}
      />
      <Trans
        i18nKey="shared:footer.term_of_use"
        t={t}
        components={{
          a: (
            <PortalLink
              href={`${legalDoc}/terms-of-use`}
              target="_blank"
              variant="default"
              underlineOnHover
            >
              0
            </PortalLink>
          ),
        }}
      />
    </PortalFooterContainer>
  );
}

export default memo(PortalFooter);
